// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__AlR8E","savePackageButton":"ClientWallet_savePackageButton__3r19b"};